/**
 * @desc 查询后台看到的出价列表
 */
import { BidRecordEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryBidRecordListParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/operation/bidRecord/list'

export const queryBidRecordListApi = (
  params?: QueryBidRecordListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<BidRecordEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryBidRecordListApi.method = method
queryBidRecordListApi.url = url
